var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4133 12.4167L0.10498 23.8404L0.106647 23.8469C0.28899 24.4711 0.676295 25.0197 1.20916 25.4086C1.74203 25.7975 2.39104 26.0053 3.05665 26C3.62165 26 4.15165 25.8538 4.60665 25.6003L4.64331 25.5792L17.3716 18.59L11.4133 12.415V12.4167Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.855 10.4714L22.8433 10.4649L17.3483 7.43262L11.1566 12.6749L17.3699 18.5866L22.8366 15.5852C23.7949 15.0929 24.445 14.1325 24.445 13.0226C24.445 11.9225 23.8033 10.9654 22.855 10.4714Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.103333 2.16113C0.0366667 2.39838 0 2.64863 0 2.90863V23.0911C0 23.3511 0.035 23.603 0.103333 23.8386L11.8033 12.709L0.101667 2.16113H0.103333Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4966 13L17.35 7.43113L4.63331 0.416001C4.155 0.143212 3.61078 -0.000380837 3.05665 7.5858e-07C1.64331 7.5858e-07 0.44998 0.914876 0.10498 2.15638V2.15963L11.495 13H11.4966Z",
    fill: "#34A853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.a4fcf90d92728005dbf176fd29f51e53.svg";
export { ForwardRef as ReactComponent };